export default {"src":"/_next/static/image/public/images/ic_express_schedule_cart.024985f8a8cb42617e2c68d4d171a3b3.svg","height":20,"width":71};